import { render, staticRenderFns } from "./Starter.vue?vue&type=template&id=befdc2d0&scoped=true&"
import script from "./Starter.vue?vue&type=script&lang=js&"
export * from "./Starter.vue?vue&type=script&lang=js&"
import style0 from "./Starter.vue?vue&type=style&index=0&id=befdc2d0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befdc2d0",
  null
  
)

export default component.exports